var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes},_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }